import PromotionFrequencyAndDepth from "./PromotionFrequencyAndDepth";
export default PromotionFrequencyAndDepth;
